const ArticleAuthor = ({ author }: { author: string }) =>
  author ? <p data-test="article-author">By {author}</p> : null;

export default ArticleAuthor;
